import AssessmentServiceApi from "../../services/assessment-api";
const bulkReactivate = (data) => {
  return function (dispatch, getState) {
    return AssessmentServiceApi.bulkReactivate(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};
export { bulkReactivate };
